import { memo, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Spacings, Fonts } from '@styles/index';
import Switch from '@material-ui/core/Switch';
import P1 from '@base/P1/P1';

const Wrapper = styled.div`
  margin-bottom: ${Spacings.SPACING_10B};
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Label = styled(P1)`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.LARGE};
  color: ${({ theme }) => theme.colors.fontGrey};
`;

const DarkModeSwitch = ({ onToggleDarkMode, isDarkModeOn, label }) => {
  const [isChecked, setIsChecked] = useState(isDarkModeOn);

  const handleSwitchOnChange = (event, checked) => {
    setIsChecked(checked);
    onToggleDarkMode(checked);
  };

  return (
    <Wrapper>
      <Switch
        checked={isChecked}
        onChange={handleSwitchOnChange}
        value="darkMode"
        color="primary"
      />
      <Label>{label}</Label>
    </Wrapper>
  );
};

export default memo(DarkModeSwitch);

DarkModeSwitch.propTypes = {
  onToggleDarkMode: PropTypes.func.isRequired,
  isDarkModeOn: PropTypes.bool,
  label: PropTypes.string
};

DarkModeSwitch.defaultProps = {
  isDarkModeOn: false,
  label: 'Dark Mode'
};
